import {Navigate, Route, Routes} from 'react-router-dom';

import {MainLayout} from '../layout/MainLayout';
import {ERoutes} from '@constants/routes';
import AuthPage from '@pages/AuthPage';
import AuthRecoveryPage from '@pages/AuthRecoveryPage';
import NewPasswordPage from '@pages/NewPasswordPage';
import DashboardPage from '@pages/DashboardPage';
import SystemDetailsPage from '@pages/SystemDetailsPage';
import ComparePage from '@pages/ComparePage';
import LicensePage from '@pages/LicensePage';
import EditSystemPlanPage from '@pages/EditSystemPlanPage';
import ProfilePage from '@pages/ProfilePage';
import TestsPage from '@pages/TestsPage';
import UsersPage from '@pages/UsersPage';
import {useDispatch} from 'react-redux';
import {FC, PropsWithChildren, useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router';
import {logout, setTokens} from '@store/slices/users';
import {
  registerTokenExpiredCallback,
  startTokenExpiryChecker,
} from '@utils/tokenExpiryHandler';
import AcceptInvitePage from '@pages/AcceptInvitePage';

export const PrivateRoute: FC<PropsWithChildren> = ({children}) => {
  const token = localStorage.getItem('authToken');
  const location = useLocation();

  console.log('private', token);

  if (!token) {
    // Редирект на страницу авторизации с сохранением текущего пути
    return (
      <Navigate
        to={ERoutes.AUTHORIZATION}
        state={{from: location.pathname + location.search}}
        replace
      />
    );
  }

  return <>{children}</>;
};

export const PublicRoute: FC<PropsWithChildren> = ({children}) => {
  return <>{children}</>;
};

export const AppRouter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const access_token = localStorage.getItem('authToken');
  const refresh_token = localStorage.getItem('refreshToken');

  useEffect(() => {
    // Проверяем наличие токена в localStorage при загрузке
    if (access_token && refresh_token) {
      dispatch(setTokens({access_token, refresh_token}));
    }
  }, [access_token, refresh_token]);

  useEffect(() => {
    // Запускаем проверку истечения токена
    const cleanupExpiryChecker = startTokenExpiryChecker();

    // Регистрируем callback для обработки истечения токена
    const cleanupTokenCallback = registerTokenExpiredCallback(() => {
      dispatch(logout());
      navigate(ERoutes.AUTHORIZATION, {
        state: {from: `${location.pathname}${location.search}`},
      });
    });

    return () => {
      cleanupExpiryChecker();
      cleanupTokenCallback();
    };
  }, [navigate]);

  return (
    <Routes>
      {/* Приватные маршруты */}
      <Route
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }>
        <Route path={ERoutes.MAIN} element={<DashboardPage />} />
        <Route path={ERoutes.SYSTEMS} element={<DashboardPage />} />
        <Route path={ERoutes.SYSTEM_DETAILS} element={<SystemDetailsPage />} />
        <Route path={ERoutes.SYSTEM_COMPARE} element={<ComparePage />} />
        <Route path={ERoutes.SYSTEM_PLAN_EDIT} element={<EditSystemPlanPage />} />
        <Route path={ERoutes.TESTS} element={<TestsPage />} />
        <Route path={ERoutes.USERS} element={<UsersPage />} />
        <Route path={ERoutes.PROFILE} element={<ProfilePage />} />
        <Route path={ERoutes.LICENSE} element={<LicensePage />} />
      </Route>
      {/* Публичные маршруты */}
      <Route
        path={ERoutes.AUTHORIZATION}
        element={
          <PublicRoute>
            <AuthPage />
          </PublicRoute>
        }
      />
      <Route
        path={ERoutes.AUTH_RECOVERY}
        element={
          <PublicRoute>
            <AuthRecoveryPage />
          </PublicRoute>
        }
      />
      <Route
        path={ERoutes.NEW_PASSWORD}
        element={
          <PublicRoute>
            <NewPasswordPage />
          </PublicRoute>
        }
      />
      <Route
        path={ERoutes.ACCEPT_INVITE}
        element={
          <PublicRoute>
            <AcceptInvitePage />
          </PublicRoute>
        }
      />

      {/* Редирект для неизвестных маршрутов */}
      <Route path="*" element={<Navigate to={ERoutes.MAIN} replace />} />
    </Routes>
  );
};
